function notNullOrEmpty(value) {
  if (value == null || !value?.length) {
    return false;
  }
  return true;
}
export default {
  notNullOrEmpty
};